import { render, staticRenderFns } from "./Groepslessen.vue?vue&type=template&id=28201a38&scoped=true&"
import script from "./Groepslessen.vue?vue&type=script&lang=js&"
export * from "./Groepslessen.vue?vue&type=script&lang=js&"
import style0 from "./Groepslessen.vue?vue&type=style&index=0&id=28201a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28201a38",
  null
  
)

export default component.exports